import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import './assets/css/style-page-modal.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function PageRegistration() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        // -- Custom Select Script --
        const customSelectWrappers = document.querySelectorAll('.custom-select-wrapper');

        customSelectWrappers.forEach(wrapper => {
            const display = wrapper.querySelector('.custom-select-display');
            const optionsContainer = wrapper.querySelector('.custom-select-options');
            const options = wrapper.querySelectorAll('.custom-select-option');
            const hiddenInput = wrapper.querySelector('input[type="hidden"]');
            const valueSpan = display.querySelector('.custom-select-value');

            display.addEventListener('click', (e) => {
                if (!wrapper.classList.contains('open')) {
                    closeAllSelects(); 
                }
                wrapper.classList.toggle('open');
                display.setAttribute('aria-expanded', wrapper.classList.contains('open'));
                e.stopPropagation(); 
            });

            display.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (!wrapper.classList.contains('open')) {
                        closeAllSelects();
                    }
                    wrapper.classList.toggle('open');
                    display.setAttribute('aria-expanded', wrapper.classList.contains('open'));
                    if (wrapper.classList.contains('open')) {
                        const selectedOption = optionsContainer.querySelector('.selected') || optionsContainer.querySelector('.custom-select-option:not([data-value=""])');
                        if (selectedOption) {
                            selectedOption.focus();
                        } else {
                            optionsContainer.querySelector('.custom-select-option')?.focus();
                        }
                    }
                } else if (e.key === 'Escape') {
                    if (wrapper.classList.contains('open')) {
                        wrapper.classList.remove('open');
                        display.setAttribute('aria-expanded', 'false');
                        display.focus(); 
                    }
                } else if (e.key === 'ArrowDown' && wrapper.classList.contains('open')) {
                    e.preventDefault();
                    const firstOption = optionsContainer.querySelector('.custom-select-option');
                    firstOption?.focus();
                }
            });

            options.forEach(option => {
                option.addEventListener('click', function() {
                    const selectedValue = this.getAttribute('data-value');
                    const selectedText = this.textContent;

                    if (selectedValue) {
                        valueSpan.textContent = selectedText;
                        display.classList.add('has-value'); 
                    } else {
                        valueSpan.textContent = '';
                        display.classList.remove('has-value');
                    }

                    hiddenInput.value = selectedValue;

                    options.forEach(opt => opt.classList.remove('selected'));
                    this.classList.add('selected');

                    wrapper.classList.remove('open');
                    display.setAttribute('aria-expanded', 'false');
                    display.focus(); 

                    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                });

                option.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        option.click(); 
                    } else if (e.key === 'Escape') {
                        wrapper.classList.remove('open');
                        display.setAttribute('aria-expanded', 'false');
                        display.focus();
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        const nextOption = option.nextElementSibling;
                        nextOption?.focus();
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        const prevOption = option.previousElementSibling;
                        prevOption?.focus();
                    }
                });
            });
        });

        function closeAllSelects() {
            customSelectWrappers.forEach(wrapper => {
                if (wrapper.classList.contains('open')) {
                    wrapper.classList.remove('open');
                    wrapper.querySelector('.custom-select-display').setAttribute('aria-expanded', 'false');
                }
            });
        }

        document.addEventListener('click', function(e) {
            let clickedInsideASelect = false;
            customSelectWrappers.forEach(wrapper => {
                if (wrapper.contains(e.target)) {
                    clickedInsideASelect = true;
                }
            });
            if (!clickedInsideASelect) {
                closeAllSelects();
            }
        });

        const handleDocumentClick = (e) => {
            let clickedInsideASelect = false;
            customSelectWrappers.forEach(wrapper => {
                if (wrapper.contains(e.target)) {
                    clickedInsideASelect = true;
                }
            });
            if (!clickedInsideASelect) {
                closeAllSelects();
            }
        };

        document.addEventListener('click', handleDocumentClick);

        const form = document.getElementById('demoRequestForm');
        if (form) {
            form.addEventListener('submit', function(event) {
                const hiddenSelectInput = form.querySelector('#serviceType') || form.querySelector('#routename');
                const displaySelect = form.querySelector('#serviceTypeDisplay') || form.querySelector('#routeNameDisplay');
                if (hiddenSelectInput && hiddenSelectInput.required && !hiddenSelectInput.value) {
                    event.preventDefault(); 
                    displaySelect.style.borderColor = '#dc3545'; 
                    displaySelect.focus();
                } else {
                    displaySelect.style.borderColor = '#ced4da'; 
                }
            });
            const hiddenSelectInput = form.querySelector('#serviceType') || form.querySelector('#routename');
            if (hiddenSelectInput) {
                hiddenSelectInput.addEventListener('change', () => {
                    const displaySelect = form.querySelector('#serviceTypeDisplay') || form.querySelector('#routeNameDisplay');
                    if (hiddenSelectInput.value) {
                        displaySelect.style.borderColor = '#ced4da';
                    }
                });
            }
        }

        // --- Main Form Submission Logic ---
        const submitButton = document.getElementById('submitDemoButton');
        const resetButton = document.getElementById('resetDemoButton');
        const formErrorFeedback = document.getElementById('formErrorFeedback');
        
        fetch('https://hanbiro.com/generate_token.php', { credentials: 'include' }) // include cookies/session
        // fetch('http://localhost/api/generate_token.php', { credentials: 'include' }) // for local testing
        .then(res => res.json())
        .then(data => {
            document.getElementById('csrf_token').value = data.csrf_token;
        });

            const handleFormSubmit = async (event) => {
                event.preventDefault(); // Prevent default form submission
    
                // Basic client-side validation (add more as needed)
                let isValid = true;
                form.querySelectorAll('[required]').forEach(input => {
                    if (!input.value) {
                        isValid = false;
                        // Add visual feedback for invalid fields
                        input.classList.add('is-invalid');
                        const displaySelect = input.closest('.custom-select-wrapper')?.querySelector('.custom-select-display');
                        if (displaySelect) {
                            displaySelect.classList.add('is-invalid');
                            displaySelect.style.borderColor = '#dc3545'; // Example invalid style
                        }
                    } else {
                        input.classList.remove('is-invalid');
                        const displaySelect = input.closest('.custom-select-wrapper')?.querySelector('.custom-select-display');
                        if (displaySelect) {
                            displaySelect.classList.remove('is-invalid');
                            displaySelect.style.borderColor = ''; // Reset style
                        }
                    }
                });
    
                const privacyCheck = form.querySelector('#privacyCheck');
                if (!privacyCheck.checked) {
                    isValid = false;
                    privacyCheck.classList.add('is-invalid');
                    // Optionally add feedback near the checkbox
                } else {
                    privacyCheck.classList.remove('is-invalid');
                }
    
                if (!isValid) {
                     if (formErrorFeedback) {
                        formErrorFeedback.textContent = '필수 입력 항목을 모두 작성해주세요.';
                        formErrorFeedback.classList.remove('d-none');
                    } else {
                        alert('필수 입력 항목을 모두 작성해주세요.');
                    }
                    return; // Stop submission if invalid
                }
    
                if (formErrorFeedback) {
                    formErrorFeedback.classList.add('d-none'); // Hide previous errors
                }
    
    
                // --- Get Form Data Elements ---
                const serviceTypeHiddenInput = form.querySelector('#serviceTypeInput');
                const companyNameInput = form.querySelector('#companyName');
                const employeeCountInput = form.querySelector('#employeeCountInput');
                const routeNameInput = form.querySelector('#routeNameInput');
                const domainInput = form.querySelector('#domainInput');
                const companyAddressInput = form.querySelector('#companyAddressInput');
                const contactNameInput = form.querySelector('#contactNameInput');
                const contactPhoneInput = form.querySelector('#contactPhoneInput');
                const contactEmailInput = form.querySelector('#contactEmailInput');
                const notesTextarea = form.querySelector('#notesTextarea');
    
                // --- Generate and set Client-Side CSRF Token ---
                const token = document.getElementById('csrf_token').value;
                if (!token) {
                    console.error('CSRF token is missing.');
                    if (formErrorFeedback) {
                        formErrorFeedback.textContent = '보안 오류가 발생했습니다. 페이지를 새로고침하세요.';
                        formErrorFeedback.classList.remove('d-none');
                    } else {
                    alert('보안 오류가 발생했습니다. 페이지를 새로고침하세요.');
                    }
                    return;
                }
    
                // --- Prepare Data for Sending ---
                const json = {
                    Service: serviceTypeHiddenInput.value,
                    Name: contactNameInput.value,
                    Email: contactEmailInput.value,
                    regCell: contactPhoneInput.value,
                    regcName: companyNameInput.value,
                    regAddress: companyAddressInput.value,
                    regUsernum: employeeCountInput.value,
                    regDomain: domainInput.value,
                    regRouteName: routeNameInput.value,
                    memo: notesTextarea.value,
                    csrf_token: token,
                    checkbox: privacyCheck.checked ? "on" : ""
                };
                const urlEncodedData = new URLSearchParams();
    
                for (const key in json) {
                    urlEncodedData.append(key, json[key]);
                }
                console.log("Form Data Prepared:", urlEncodedData.toString());
    
                // --- Send Data using Fetch ---
                submitButton.disabled = true;
                submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 신청 중...';
    
                const apiUrl = 'https://hanbiro.com/software/Index_Up.php';
                // const apiUrl = 'http://localhost/api/Index_Up.php'; // For local testing
    
                try {
                    const response = await fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Accept': 'application/json'
                        },
                        body: urlEncodedData.toString()
                    });
                
                    const contentType = response.headers.get('content-type');
                
                    if (!response.ok) {
                        let errorMessage = `서버 오류 (${response.status})`;
                
                        if (contentType && contentType.includes('application/json')) {
                            const errorData = await response.json();
                            errorMessage = errorData.message || errorMessage;
                        } else {
                            const errorText = await response.text();
                            errorMessage = errorText || errorMessage;
                        }
                
                        throw new Error(errorMessage);
                    }
                
                    let result;
                    if (contentType && contentType.includes('application/json')) {
                        result = await response.json();
                        console.log('JSON response:', result);
                        alert(result.message || "신청이 완료되었습니다!");
                    } else {
                        const text = await response.text();
                        console.error('Server returned non-JSON response:', text);
                        alert("서버 오류 발생:\n\n" + text); 
                    }
                } catch (error) {
                    console.error('Submission Error:', error);
                    if (formErrorFeedback) {
                        formErrorFeedback.textContent = `오류: ${error.message}`;
                        formErrorFeedback.classList.remove('d-none');
                    } else {
                        alert(`신청 중 오류가 발생했습니다: ${error.message}`);
                    }
                } finally {
                    submitButton.disabled = false;
                    submitButton.innerHTML = '신청하기';
                }
            };
    
            const handleFormReset = () => {
                form.reset(); // Standard form reset

                // Reset custom selects
                customSelectWrappers.forEach(wrapper => {
                    const hiddenInput = wrapper.querySelector('input[type="hidden"]');
                    const display = wrapper.querySelector('.custom-select-display');
                    const valueSpan = display?.querySelector('.custom-select-value');
                    const options = wrapper.querySelectorAll('.custom-select-option');
                    const placeholderOption = wrapper.querySelector('.custom-select-option[data-value=""]');

                    if (hiddenInput) hiddenInput.value = '';
                    if (display) display.classList.remove('has-value');
                    if (valueSpan) valueSpan.textContent = '';

                    options.forEach(opt => opt.classList.remove('selected'));
                    if (placeholderOption) placeholderOption.classList.add('selected');
                });

                // Clear validation states
                form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
                if (formErrorFeedback) formErrorFeedback.classList.add('d-none');
            };
    
    
            if (form && submitButton) {
                form.addEventListener('submit', handleFormSubmit);
            }
            if (resetButton) {
                resetButton.addEventListener('click', handleFormReset);
            }
    
    
            // Cleanup function
            return () => {
                document.removeEventListener('click', handleDocumentClick);
                if (form) {
                    form.removeEventListener('submit', handleFormSubmit);
                }
                if (resetButton) {
                resetButton.removeEventListener('click', handleFormReset);
                }
                customSelectWrappers.forEach(wrapper => {
                    const display = wrapper.querySelector('.custom-select-display');
                });
            };
        }, []); 


    return (

        <div className="pageregistration">
            <NavButton option={{
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061FF' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            
            {/* Modal */}
            <div class="registration-container">
                <form id="demoRequestForm" novalidate class="registration-form">
                    <input type="hidden" id="csrf_token"></input>
                    <div class="register text-center mb-4">
                        <div class="box-title-register d-inline-flex align-items-center">
                            <img src="https://hanbiro.com/software/img/smile.svg" />
                            <span class="title-register">30일 무료 체험</span>
                            <img src="https://hanbiro.com/software/img/smile.svg" />
                        </div>
                        <p class="title-register-decription mt-2 text-muted">기능 제한 없이 자유롭게 체험 후 결정하세요 </p>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="serviceTypeDisplay" class="form-label">신청 서비스 <span class="required-asterisk">*</span></label>
                        <div class="custom-select-wrapper">
                            <div class="custom-select-display form-control" id="serviceTypeDisplay" tabindex="0" role="combobox" aria-haspopup="listbox" aria-expanded="false">
                                <span class="custom-select-placeholder">상품 타입을 선택해 주세요.</span>
                                <span class="custom-select-value"></span>
                                <ExpandMoreIcon className="custom-select-arrow" />
                            </div>
                            <div class="custom-select-options" role="listbox">
                                <div class="custom-select-option" data-value="" role="option">상품 타입을 선택해 주세요 .</div> 
                                <div class="custom-select-option" data-value="17" role="option">메일</div>
                                <div class="custom-select-option" data-value="18" role="option">그룹웨어</div>
                                <div class="custom-select-option" data-value="15" role="option">메신저</div>
                                <div class="custom-select-option" data-value="16" role="option">Cloudisk</div>
                                <div class="custom-select-option" data-value="58" role="option">한비로 HR</div>
                            </div>
                            <input type="hidden" name="serviceType" id="serviceTypeInput" required></input>
                        </div>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">회사명 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="companyName"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">직원 수 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="employeeCountInput"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="routeNameDisplay" class="form-label">방문경로 <span class="required-asterisk"> *</span></label>
                        <div class="custom-select-wrapper">
                            <div class="custom-select-display form-control" id="routeNameDisplay" tabindex="0" role="combobox" aria-haspopup="listbox" aria-expanded="false">
                                <span class="custom-select-placeholder">한비로를 선택한 경로를 알려주세요.</span>
                                <span class="custom-select-value"></span>
                                <ExpandMoreIcon className="custom-select-arrow" />
                            </div>
                            <div class="custom-select-options" role="listbox">
                                <div class="custom-select-option" data-value="" role="option">한비로를 선택한 경로를 알려주세요. </div> 
                                <div class="custom-select-option" data-value="intro" role="option">지인소개</div>
                                <div class="custom-select-option" data-value="google" role="option">구글 검색 엔진</div>
                                <div class="custom-select-option" data-value="naver" role="option">네이버 검색 엔진</div>
                                <div class="custom-select-option" data-value="next-search" role="option">다음 검색 엔진</div>
                                <div class="custom-select-option" data-value="other" role="option">기타 검색엔진</div>
                                <div class="custom-select-option" data-value="blog" role="option">블로그/카페</div>
                                <div class="custom-select-option" data-value="k-non" role="option">K-비대면 서비스 바우처</div>
                                <div class="custom-select-option" data-value="etc" role="option">기타</div>
                            </div>
                            <input type="hidden" name="routeName" id="routeNameInput" required></input>
                        </div>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">도메인 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="domainInput" placeholder="ex&#41; yourdomain.com"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">회사 주소 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="companyAddressInput"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">담당자 이름 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="contactNameInput"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">담당자 연락처 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="contactPhoneInput"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">담당자 메일주소 <span class="required-asterisk"> *</span></label>
                        <input type="text" class="form-control" id="contactEmailInput"></input>
                    </div>
                    <div class="mb-3 control-group">
                        <label for="control-label" class="form-label">비고  <span class="required-asterisk"> *</span></label>
                        <div class="form-floating">
                            <textarea type="text" class="form-control" id="notesTextarea"></textarea>
                            <div class="mb-3 form-check">
                                <input type="checkbox" class="form-check-input" id="privacyCheck" name="privacyCheck" value="agreed"></input>
                                <label class="form-check-label" for="privacyCheck">개인정보 수집 동의</label>
                            </div>
                        </div>
                    </div>
                    <div class="registration-footer">
                        <button type="submit" class="btn btn-primary" id="submitDemoButton">신청하기</button>
                        <button type="button" class="btn btn-secondary" id="resetDemoButton">다시 작성</button>
                    </div>
                </form>
            </div>                
                        
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    )
}

export default PageRegistration;